import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { IOpenMarketProduct } from '../../../../interfaces/Product.interfaces';
import { getOpenMarketProducts } from '../../../../api/product/queries/getOpenMarketProducts';

interface IUseGetSellProductsQueryParams {
  searchParam?: {
    status: string;
    count?: number;
  };
  options?: UseQueryOptions<IOpenMarketProduct[], AxiosError>;
}

export const useGetOpenMarketProductsQuery = ({ searchParam, options }: IUseGetSellProductsQueryParams) => {
  return useQuery<IOpenMarketProduct[], AxiosError>(
    ['user-sell-tractors', `status=${searchParam?.status}`, `count=${searchParam?.count}`],
    () => getOpenMarketProducts({ searchParam }),
    options,
  );
};
